import { useMemo, useState } from 'react';
import { ExplainerCard } from '../hub/ExplainerCard';
import type { Explainer } from '../hub/explainerRegistry';

interface Props {
  explainers: Explainer[];
  highlightedExplainerId?: string;
  onView: (id: string) => void;
  onStar: (id: string) => void;
  onReport: (id: string) => void;
}

export function ExplainersPage({
  explainers,
  highlightedExplainerId,
  onView,
  onStar,
  onReport,
}: Props) {
  const [search, setSearch] = useState('');

  const grouped = useMemo(() => {
    const query = search.trim().toLowerCase();
    const filtered = explainers.filter(exp => {
      if (!query) return true;
      return `${exp.title} ${exp.description} ${exp.topic}`.toLowerCase().includes(query);
    });

    return filtered.reduce<Record<string, Explainer[]>>((acc, explainer) => {
      const category = explainer.topic;
      acc[category] = acc[category] ?? [];
      acc[category].push(explainer);
      return acc;
    }, {});
  }, [explainers, search]);

  return (
    <div className="site-visit-layer">
      <p className="site-visit-layer__label">Explainers library</p>
      <input
        value={search}
        onChange={event => setSearch(event.target.value)}
        placeholder="Search explainers"
        className="hub-select"
        style={{ maxWidth: 320, marginBottom: 12 }}
      />

      {Object.entries(grouped).map(([category, categoryExplainers]) => (
        <details key={category} open={categoryExplainers.some(exp => exp.id === highlightedExplainerId)}>
          <summary style={{ textTransform: 'capitalize', fontWeight: 600, margin: '8px 0' }}>
            {category} ({categoryExplainers.length})
          </summary>
          <div className="explainer-cards">
            {categoryExplainers.map(exp => (
              <div
                key={exp.id}
                style={exp.id === highlightedExplainerId ? { outline: '2px solid #4f46e5', borderRadius: 12 } : undefined}
              >
                <ExplainerCard
                  explainer={exp}
                  onView={onView}
                  onStar={onStar}
                  onReport={onReport}
                />
              </div>
            ))}
          </div>
        </details>
      ))}
    </div>
  );
}
